import React, { useState, useEffect, useContext } from 'react';
import {IProps} from './types';
import Button from '@components/Button';
import { useDispatch } from 'react-redux';
import * as S from './styles';
import C from '@assets/themes/colors';

const FolderDelete:React.FC<IProps> = (props) => {
  const [open, setOpen] = useState(props.open);
  const [checked, setChecked]=useState(false);
  const [saving, setSaving] = useState(false);
  
  const handleCheckboxChange = (evt:React.ChangeEvent<HTMLInputElement>) => setChecked(evt.currentTarget.checked);

  const handleSave = () => {
    setSaving(true);
    if (props.onActions) {
      if (checked) props.onActions("DELETEFOLDERDESIGNS");
      else props.onActions("DELETEFOLDER");
    }
  }

  return (
    <S.Root style={{
      display: open ? 'flex' : 'none',
    }} >
      <S.BoxContainer>
        <S.TitleContainer>
          <S.LeftSide>
            <S.Title>
              Delete Folder
            </S.Title>
          </S.LeftSide>
        </S.TitleContainer>
        <S.Content>
          <S.Text>
            Are you sure you want to delete this folder? If you do, all of it’s contents will remain in All My Designs.
          </S.Text>
          <S.Container>
            <S.CheckboxContainer className=''>
              <S.HiddenCheckbox checked={checked} onChange={(evt)=>handleCheckboxChange(evt)}/>
              <S.StyledCheckbox checked={checked}>
                <S.Icon viewBox="0 0 24 24">
                  <polyline points="20 6 9 17 4 12" />
                </S.Icon>
              </S.StyledCheckbox>
            </S.CheckboxContainer>
            <S.Label>Delete all the designs in this folder</S.Label>
          </S.Container>
        </S.Content>
        <S.ActionsContainer>
          <S.Action>
            <Button
              label="CANCEL"
              style={{
                width: '112px',
                marginRight: 12, 
                backgroundColor: "transparent", 
                border: `1px solid ${C.DARK_BLUE}`, 
                hoverBackgroundColor: `${C.DARK_BLUE}22`,
              }}
              labelStyle={{color: C.DARK_BLUE}}
              onClick={() => props.setOpen(false)}
            />
          </S.Action>
          <S.Action>
            <Button
              label={ saving ? "DELETING..." : "DELETE"}
              style={{
                width: '112px',
                flexGrow: 0,
                backgroundColor: C.DARK_BLUE, 
                hoverBackgroundColor: `${C.DARK_BLUE}AA`,
              }} 
              onClick={handleSave}
              disabled={ false }
            />
          </S.Action>
        </S.ActionsContainer>
      </S.BoxContainer>
    </S.Root>
  );
}

export default FolderDelete;